<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.code }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AdsPlaceTabLinks />
                    <AdsPlaceCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/ads-places`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import AdsPlaceTabLinks from '@/components/ads-places/AdsPlaceTabLinks';
    import AdsPlaceCard from '@/components/ads-places/AdsPlaceCard';

    export default {
        name: 'AdsPlace',

        components: {
            AdsPlaceTabLinks,
            AdsPlaceCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/ads-places/${id}`)).data;
            },
        },
    };
</script>
